export default __webpack_public_path__ + "static/media/640_business03-en-web.0bc8b346.png";